import { useAppSelector } from './useAppSelector';
import { getFinalUTCDateRange } from './useFormatDateTime';

const useDateAndTime = () => {
  const range = useAppSelector((state) => state.dateFilter);
  const selectedZone = useAppSelector((state) => state.configSlice.timeZone);
  const { startDate, endDate } = getFinalUTCDateRange(range, selectedZone);

  return { startDate, endDate, range };
};

export default useDateAndTime;
